'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const PreviewIdContext = /*#__PURE__*/ React.createContext(undefined);
const PreviewIdSetter = /*#__PURE__*/ React.createContext(undefined);
export function PreviewIdProvider({ children, value: defaultPreviewId }) {
    const [previewId, setPreviewId] = React.useState(defaultPreviewId);
    const previewIdSetter = React.useCallback((value)=>{
        const newPreviewId = typeof value === 'string' ? value : null;
        setPreviewId(newPreviewId);
    }, []);
    return /*#__PURE__*/ _jsx(PreviewIdContext, {
        value: previewId,
        children: /*#__PURE__*/ _jsx(PreviewIdSetter, {
            value: previewIdSetter,
            children: children
        })
    });
}
export default function usePreviewId() {
    const context = React.use(PreviewIdContext);
    if (context === undefined) {
        throw new Error('usePreviewId must be used within a PreviewIdProvider');
    }
    return context;
}
export function useSetPreviewId() {
    const context = React.use(PreviewIdSetter);
    if (context === undefined) {
        throw new Error('useSetPreviewId must be used within a PreviewIdProvider');
    }
    return context;
}
export function usePreviewIdAtom() {
    return [
        usePreviewId(),
        useSetPreviewId()
    ];
}

//# sourceMappingURL=previewIdAtom.js.map